import { Grid } from "@material-ui/core";
import React from "react";
import { SocItem } from "../../domain/SocItem";
import { SectionProps } from "./SectionProps";
import { Controller } from "react-hook-form";
import { Error } from "../common/Error";
import { Select } from "@ofqual/portal-components/components/Select";
import { fieldLabelsOfqual } from "./fieldLabels";
import {
  followupService,
  followupStatusService,
  ragRatingService,
  satisfiedClosureService,
  usersService,
} from "../../services";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { UserRole } from "../../domain/userRole";

export const OrganisationalStabilityOfqual: React.FC<SectionProps<SocItem>> = (
  sectionProps
) => {
  const { control, disabled, errors, clearErrors } = sectionProps;

  const [
    ragRatingLookups,
    followupLookups,
    followupStatusLookups,
    usersLookups,
    satisfiedClosureLookups,
  ] = useLookup(
    ragRatingService,
    followupService,
    followupStatusService,
    {
      service: usersService,
      id: "upn",
      label: (item) => (item.fullName ? item.fullName : item.upn),
      params: {
        userType: 1,
        role: [UserRole.ITAdmin, UserRole.OfqualSocAdmin],
        active: true,
      },
    },
    satisfiedClosureService
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="organisationStabilityRagRating"
          rules={{ required: true }}
          render={({ onChange, ...props }) => (
            <Select
              label={fieldLabelsOfqual.organisationalStabilityRagRating}
              readOnly={disabled}
              datatest="organisationStabilityRagRating-field"
              required
              onChange={(e) => {
                if (e.target.value !== null) {
                  clearErrors("organisationStabilityRagRating");
                }
                onChange(e);
              }}
              {...props}
            >
              {ragRatingLookups}
            </Select>
          )}
        />
        {errors.organisationStabilityRagRating?.type === "required" && (
          <Error data-test="organisationStabilityRagRating-validation">
            This field is required
          </Error>
        )}
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="organisationFollowUp"
          rules={{ required: true }}
          render={({ onChange, ...props }) => (
            <Select
              label={fieldLabelsOfqual.organisationFollowUp}
              readOnly={disabled}
              datatest="organisationFollowUp-field"
              required
              onChange={(e) => {
                if (e.target.value !== null) {
                  clearErrors("organisationFollowUp");
                }
                onChange(e);
              }}
              {...props}
            >
              {followupLookups}
            </Select>
          )}
        />
        {errors.organisationFollowUp?.type === "required" && (
          <Error data-test="organisationalFollowUp-validation">
            This field is required
          </Error>
        )}
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="organisationFollowUpStatus"
          rules={{ required: true }}
          render={({ onChange, ...props }) => (
            <Select
              label={fieldLabelsOfqual.organisationFollowUpStatus}
              readOnly={disabled}
              datatest="organisationFollowUpStatus-field"
              required
              onChange={(e) => {
                if (e.target.value !== null) {
                  clearErrors("organisationFollowUpStatus");
                }
                onChange(e);
              }}
              {...props}
            >
              {followupStatusLookups}
            </Select>
          )}
        />
        {errors.organisationFollowUpStatus?.type === "required" && (
          <Error data-test="organisationFollowUpStatus-validation">
            This field is required
          </Error>
        )}
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="organisationFollowUpLead"
          rules={{ required: true }}
          render={({ onChange, ...props }) => (
            <Select
              label={fieldLabelsOfqual.lead}
              readOnly={disabled}
              datatest="organisationFollowUpLead-field"
              required
              onChange={(e) => {
                if (e.target.value !== null) {
                  clearErrors("organisationFollowUpLead");
                }
                onChange(e);
              }}
              {...props}
            >
              {usersLookups}
            </Select>
          )}
        />
        {errors.organisationFollowUpLead?.type === "required" && (
          <Error data-test="organisationFollowUpLead-validation">
            This field is required
          </Error>
        )}
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="riskMarketsClosureStatus"
          rules={{ required: true }}
          render={({ onChange, ...props }) => (
            <Select
              label={fieldLabelsOfqual.riskMarketsClosureStatus}
              readOnly={disabled}
              datatest="riskMarketsClosureStatus-field"
              required
              onChange={(e) => {
                if (e.target.value !== null) {
                  clearErrors("riskMarketsClosureStatus");
                }
                onChange(e);
              }}
              {...props}
            >
              {satisfiedClosureLookups}
            </Select>
          )}
        />
        {errors.riskMarketsClosureStatus?.type === "required" && (
          <Error data-test="riskMarketsClosureStatus-validation">
            This field is required
          </Error>
        )}
      </Grid>
    </Grid>
  );
};
